import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, lead, dark = false, align = "left" }) {
  return (
    <Reveal className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
      {eyebrow && (
        <p className={`text-[11px] font-semibold uppercase tracking-[0.3em] ${dark ? "text-euca-sage" : "text-euca"}`}>
          {eyebrow}
        </p>
      )}
      <h2 className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-[2.75rem] font-medium leading-tight tracking-tight ${dark ? "text-euca-mist" : "text-euca-dark"}`}>
        {title}
      </h2>
      {lead && (
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-euca-mist/70" : "text-mutedsoft"}`}>
          {lead}
        </p>
      )}
    </Reveal>
  );
}

export function TickList({ items, dark = false, columns = 2 }) {
  return (
    <ul className={`grid gap-x-10 gap-y-4 ${columns === 2 ? "sm:grid-cols-2" : ""}`}>
      {items.map((item, i) => (
        <Reveal key={item} delay={i * 0.04} y={14}>
          <li className={`flex items-start gap-3 text-base leading-relaxed ${dark ? "text-euca-mist/80" : "text-charcoal/85"}`}>
            <svg viewBox="0 0 24 24" className={`mt-1 h-4 w-4 shrink-0 ${dark ? "text-euca-sage" : "text-euca"}`} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
              <path d="M12 20 C12 13 12 8 13 3" />
              <path d="M12 15 Q7.5 14 5.5 10 Q10 11 12 15 Z" />
              <path d="M12.2 12 Q17 11 19 7.5 Q14.5 8.5 12.2 12 Z" />
            </svg>
            {item}
          </li>
        </Reveal>
      ))}
    </ul>
  );
}

export { EASE };
